module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/toggle/toggle.button.template.html
// module id = 972
// module chunks = 0